import {changeEvent, dispatchCustomEvent} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";

changeEvent('#product-list-page .product-configuration-drop[data-option-type="selectable"] input[name="drop"]', true, function(element) {
    let mainContainer = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = mainContainer.querySelector('.open-configuration .preview-option-drop');

    dispatchCustomEvent(
        'productTissueDropChanged',
        {
            'option': container,
            'previewElement': previewElement,
        }
    );
    container.querySelectorAll('.drop.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    mainContainer.querySelector('input[name="option-drop"]').value = element.value;
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});